import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {CertificatesTable} from '../tables/CertificatesTable';

// FNP-1193 — the certificates page.
//
// ⚠️ NO ROUTE PARAMS AND NO CONNECTION IN THE URL, unlike the records page.
//
// `listCertificates` takes only `limit` and `nextToken`; the tenant is a key
// condition the server builds from the caller's own claim. There is nothing to
// read out of the path or the query string, and nothing to guard against being
// absent — which is why this page has none of the records page's up-front
// connection check.
//
// ⚠️ NO DETAIL PAGE EITHER, deliberately. Everything a certificate has that is
// worth reading — its covered names, its status, its expiry, and the validation
// records that explain a stuck one — is on the row or in its expansion. A
// detail route would be a second address for the same content, and the thing an
// operator actually needs to reach is the ZONE holding the validation record,
// which the expansion links to directly.
export const IndexPage = () => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <CertificatesTable/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
